import React, {useContext} from 'react';
import {Box} from '@mui/material';
import {PathDesignContext} from 'src/components/path-design-context';
import {getColorOnScale, getPathColorOnScale} from 'src/components/victory/chartTheme';
import styles from './styles.module.scss';

interface LabelProps {
  color: string;
  value: string;
}

function Label(props: LabelProps) {
  return (
    <div className={styles.container} data-testid={`legend-label-${props.value}`}>
      <span
        data-testid={`legend-label-color-${props.value}`}
        className={styles.icon}
        style={{backgroundColor: props.color}}
      />
      {props.value}
    </div>
  );
}

interface LegendProps {
  labels?: string[];
}

export default function Legend(props: LegendProps) {
  const path = useContext(PathDesignContext);

  const {labels = []} = props;
  if (labels.length === 0) {
    return null;
  }

  return (
    <Box display="flex" position="absolute" right={32} data-testid="legend">
      {labels.map((label, index) => (
        <Label
          key={`label-${index}`}
          value={label}
          color={path.enabled ? getPathColorOnScale(index) : getColorOnScale(index)}
        />
      ))}
    </Box>
  );
}
